import React from 'react';
import { Badge } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const FinancialAdvisor = ({ insights, isLoading }) => {
  const getSeverityColor = (severity) => {
    const colors = { high: 'danger', medium: 'warning', low: 'info' };
    return colors[severity?.toLowerCase()] || 'secondary';
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Cost Optimization': '#38a169',
      'Budget Management': '#3182ce',
      'Risk Management': '#e53e3e',
      'Forecasting': '#d69e2e'
    };
    return colors[category] || '#718096';
  };

  return (
    <div className="rounded shadow" style={{
      backgroundColor: '#fff',
      borderRadius: '10px',
      height: '480px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>
      <div style={{ backgroundColor: '#6D5BFF', color: '#fff', padding: '15px', fontSize: '1.2rem', borderRadius: '10px 10px 0 0' }}>
        Financial Advisor
      </div>
      
      <div className="flex-grow-1" style={{ overflowY: 'auto', padding: '16px' }}>
        {isLoading ? (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} />
            <p className="text-muted mt-3 mb-1" style={{ fontWeight: '500' }}>Analyzing your costs...</p>
            <small className="text-muted">This may take a moment</small>
          </div>
        ) : !insights || insights.length === 0 ? (
          <div className="text-center text-muted py-5">No recommendations available</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {insights.map((insight, idx) => (
              <div 
                key={idx} 
                className="rounded p-3" 
                style={{ 
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <strong style={{ 
                    fontSize: '0.9rem', 
                    color: '#2d3748',
                    flex: 1,
                    marginRight: '8px',
                    lineHeight: '1.4',
                    wordBreak: 'break-word'
                  }}>
                    {insight.title}
                  </strong>
                  <Badge 
                    bg={getSeverityColor(insight.severity)} 
                    style={{ 
                      textTransform: 'uppercase',
                      fontSize: '0.65rem',
                      padding: '4px 8px',
                      flexShrink: 0,
                      color: '#fff'
                    }}
                  >
                    {insight.severity}
                  </Badge>
                </div>
                <div className="mb-2">
                  <span style={{ 
                    fontSize: '0.7rem',
                    fontWeight: '500',
                    backgroundColor: getCategoryColor(insight.category),
                    color: '#fff',
                    padding: '3px 10px',
                    borderRadius: '12px',
                    display: 'inline-block',
                    whiteSpace: 'nowrap'
                  }}>
                    {insight.category}
                  </span>
                </div>
                <p style={{ 
                  fontSize: '0.85rem', 
                  marginBottom: '10px',
                  color: '#4a5568',
                  lineHeight: '1.5',
                  wordBreak: 'break-word'
                }}>
                  {insight.executiveSummary}
                </p>
                <div className="text-primary" style={{ 
                  fontSize: '0.75rem',
                  backgroundColor: '#ebf8ff',
                  padding: '8px 10px',
                  borderRadius: '6px',
                  borderLeft: '3px solid #3182ce',
                  lineHeight: '1.4',
                  wordBreak: 'break-word'
                }}>
                  <strong>Action:</strong> {insight.recommendation}
                </div>
                {insight.potentialSavings && (
                  <div className="text-success mt-2" style={{ 
                    fontSize: '0.75rem',
                    backgroundColor: '#f0fdf4',
                    padding: '8px 10px',
                    borderRadius: '6px',
                    borderLeft: '3px solid #38a169',
                    fontWeight: '500'
                  }}>
                    Potential Savings: {insight.potentialSavings}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialAdvisor;
